"use client";

import { IoMdClose } from "@react-icons/all-files/io/IoMdClose";
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";
import type { ICatalogPlatform } from "../../helpers/catalogData";
import { StyledDiv } from "./platformCatalog.styles";
import { CommonNinjaWidgetRenderer } from '../CommonNinjaWidgetRenderer/commonNinjaWidgetRenderer.comp';

interface IPlatformCatalogProps {
  platforms: ICatalogPlatform[];
}

export const PlatformCatalog = ({ platforms = [] }: IPlatformCatalogProps) => {
  const [filter, setFilter] = useState({
    name: "",
  });

  const platformList = platforms.sort((a, b) => a.order - b.order);

  const filteredPlatforms = platformList.filter((platform) =>
    platform.title.toLowerCase().includes(filter.name.toLowerCase())
  );

  return (
    <StyledDiv>
      <form className="search-components" onSubmit={(e) => e.preventDefault()}>
        <CommonNinjaWidgetRenderer widgetId="5f32cfd4-7280-4e4f-b660-f8ffd9185f19" />
        <div className="search-wrapper">
          <input
            title="Search Platforms"
            placeholder="Search for a platform..."
            value={filter.name}
            onChange={(e) => setFilter({ ...filter, name: e.target.value })}
          />
        </div>
        {filter.name && (
          <IoMdClose
            onClick={() => setFilter({ ...filter, name: "" })}
            className="reset"
            fontSize={20}
          />
        )}
      </form>
      <div className="platforms-container">
        {platforms.length > 0 &&
          filteredPlatforms.length > 0 &&
          filteredPlatforms.map((platform) => (
            <Link
              title={`${platform.appSynonym}s for ${platform.title}`}
              href={`/platforms/${platform.slug}`}
              key={platform.title}
              className="platform-card"
            >
              <div className="img-wrapper">
                <Image src={platform.logo} alt={platform.title} fill />
              </div>
            </Link>
          ))}
        {!filteredPlatforms.length && (
          <div className="no-items">
            <div className="image-wrapper">
              <Image
                src={"/assets/logo-mask.png"}
                width={100}
                height={50}
                alt="common ninja logo"
              />
            </div>
            <p>Platform not found.</p>
          </div>
        )}
      </div>
    </StyledDiv>
  );
};
